import { Link } from "react-router-dom";
import { PUBLIC_ROUTES } from "../../routes";
import MarketingShell from "./MarketingShell";

const CAPABILITIES = [
  {
    title: "Pixels die on the robot",
    body: "Raw video and audio are processed on hardware you own and are never stored, never streamed. What leaves the house is a signed abstraction — “a fall, kitchen, 7:48am” — never footage of your hallway.",
  },
  {
    title: "The Egress Ledger",
    body: "Every byte that leaves the home is itemised, signed, and readable by the family. The insurer gets events, the regulator gets attestations, the cloud planner gets redacted state. Nobody gets the video.",
  },
  {
    title: "Learning happens in the twin",
    body: "Adaptation runs against the Scan-to-Sim world twin — captured once, with consent — so the robot keeps improving without anyone, including us, training on footage of your living room.",
  },
] as const;

export default function ProductLocalMind() {
  return (
    <MarketingShell>
      <section className="sg-hero">
        <div className="sg-hero-copy">
          <p className="sg-eyebrow">Pillar D · Local Mind</p>
          <h1>The house keeps its secrets.</h1>
          <p className="sg-hero-text">
            A care robot sees bathrooms, bedrooms, and bad days, so the
            raw sensory stream should never leave it. That is the
            architecture we are building to: perception on the robot, only
            signed abstractions to the cloud, and an Egress Ledger that
            itemises every byte our software sends. Today parts of the
            perception path still call a hosted model, and the ledger will
            show you exactly that — which is the point. A family
            shouldn&rsquo;t have to trust a privacy policy. They should be
            able to check, including when the answer is inconvenient for
            us.
          </p>
          <div className="sg-hero-actions">
            <Link to={PUBLIC_ROUTES.signup} className="sg-btn sg-btn-primary">
              Request a pilot
            </Link>
            <Link to={PUBLIC_ROUTES.compliance} className="sg-btn sg-btn-secondary">
              See Compliance
            </Link>
          </div>
        </div>
      </section>

      <section className="sg-pillars">
        <div className="sg-section-heading compact">
          <p className="sg-section-kicker">What stays home</p>
          <h2>Private by architecture, not by promise.</h2>
        </div>
        <div className="sg-pillars-grid">
          {CAPABILITIES.map((item) => (
            <article className="sg-pillar" key={item.title}>
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="sg-final-cta">
        <p className="sg-section-kicker">And when the robot is docked</p>
        <h2>Docked doesn&rsquo;t mean idle.</h2>
        <p>
          The same local mind that runs the house by day can run the
          household&rsquo;s digital chores by night — the forms, the
          summaries, the appointment emails — on hardware you own,
          with nothing leaving home. The robot becomes the
          family&rsquo;s private assistant, and the Egress Ledger
          holds for that work too.
        </p>
        <div className="sg-hero-actions center">
          <Link to={PUBLIC_ROUTES.signup} className="sg-btn sg-btn-primary">
            Request a pilot
          </Link>
          <Link to={PUBLIC_ROUTES.nightShift} className="sg-btn sg-btn-secondary">
            Meet Night Shift
          </Link>
        </div>
      </section>
    </MarketingShell>
  );
}
